import { I18n } from 'i18n-js';
import buildJsx from './buildJsx';
import locales from './locales';

const LOCALE = 'en-US';
const i18n = new I18n(locales);

i18n.locale = LOCALE;
i18n.defaultLocale = LOCALE;
i18n.enableFallback = true;
i18n.jsx = buildJsx(i18n.t);

export const t = i18n.t.bind(i18n);
export const l = i18n.l.bind(i18n);
export const jsx = buildJsx(t);

i18n.jsx = jsx;

export default i18n;
